import { fetchQuery, graphql, Environment } from 'relay-runtime';
import { HandleRouteRefreshQuery as HandleRouteRefreshQueryType } from './__generated__/HandleRouteRefreshQuery.graphql';
import { urlCeHome } from '../../../../server/utils/routeConstants';

const handleRouteRefreshQuery = graphql`
  query HandleRouteRefreshQuery {
    viewer {
      id
      id
      user {
        id
        id
        accountRole {
          accountRoleTitle
        }
        permissions {
          id
          oneCommerce {
            id
            ceo {
              access
            }
            admin {
              access
            }
            preferredCustomer {
              access
            }
          }
        }
      }
    }
  }
`;

export function handleRouteRefresh(
  environment: Environment,
  accountId?: string,
) {
  // No account Id or accountId is a guest ID
  if (!accountId || accountId.includes('.')) {
    return;
  }
  return fetchQuery<HandleRouteRefreshQueryType>(
    environment,
    handleRouteRefreshQuery,
    {
      accountId,
    },
  ).then(data => {
    const { viewer } = data;
    if (viewer && viewer.user && viewer.user.accountRole) {
      const permissions = viewer && viewer.user;
      if (
        permissions &&
        permissions.oneCommerce &&
        permissions.oneCommerce.ceo &&
        permissions.oneCommerce.ceo.access
      ) {
        if (window) {
          window.location = urlCeHome;
          return;
        }
      }
      return window.location.reload();
    }
  });
}
